import React from 'react';
import PrivateRoute from 'PrivateRoutes';
import { EmailTemplete } from './components';

const routes = () => (
  <PrivateRoute exact path="/settings/email-template" component={EmailTemplete} />
);

export default routes;


// WEBPACK FOOTER //
// src/modules/screens/settings/EmailTemplete/routes.js